import { customValidateFuntionArray } from './custom_validation.service';
var FormCustomValidation = /** @class */ (function () {
    function FormCustomValidation() {
        this.customFunction = function (value, argument, element) {
            var validatorResult = {
                value: true,
            };
            return validatorResult;
        };
    }
    FormCustomValidation.prototype.getFunction = function (request) {
        return customValidateFuntionArray.validateFuntionArray[request];
    };
    FormCustomValidation.prototype.bind = function (request) {
        customValidateFuntionArray.validateFuntionArray = Object.assign({});
        if (request && Object.keys(request).length > 0) {
            Object.keys(request).forEach(function (key) {
                customValidateFuntionArray.validateFuntionArray[key] = request[key];
            });
        }
    };
    FormCustomValidation.prototype.addCustomValidateFunction = function (request) {
        customValidateFuntionArray.validateFuntionArray[request] = this.customFunction;
        console.log('this.validate', customValidateFuntionArray.validateFuntionArray);
    };
    return FormCustomValidation;
}());
export { FormCustomValidation };
//# sourceMappingURL=custom_validation.js.map